import { createStore } from 'vuex'

import createPersistedState from 'vuex-persistedstate'
import * as Cookies from 'js-cookie'

import auth from './modules/auth'
import basket from './modules/basket'
import rules from './modules/rules'

var plugins = []
//plugins.push(createPersistedState({ storage: window.sessionStorage }))


export default new createStore({
	modules: {
		auth,
		basket,
		rules
	},
	plugins: plugins
})
